module.exports = "/**\n* Import the colors and spacers from cf-design\n*/\n@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 1200px) {\n  .cf-container11 {\n    padding-left: 4.9vw !important;\n    padding-right: 4.9vw !important;\n    max-width: none !important; } }\n.breadcrumb_edge::-ms-check {\n  height: 20px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/breadcrumb/breadcrumbs.component.scss
// module id = ./src/app/core/breadcrumb/breadcrumbs.component.scss
// module chunks = main